<script lang="ts" setup>
const route = useRoute()

const { tournament } = defineProps<{ tournament: Tournament }>()

const gameId = parseInt(route.params.game as string)

const { data: game, refresh } = await useApi('/games/{game}', {
  path: {
    game: gameId,
  },
  key: `game-${gameId}`,
})

const updateGame = (updatedGame: Game) => {
  if (updatedGame.id === game.value?.id) {
    game.value = updatedGame
  }
}

useSeoMeta({
  title: `${game.value?.label ?? 'game'} | ${tournament.name} | ${tournament.event_name}`,
  description: `${game.value?.label} | ${tournament.name} | ${tournament.event_name}`,
})

defineOgImageComponent('DartsSpace', {
  siteLogo: '/light-logo.png',
  headline: `${tournament.name} @ ${tournament.event_name}`,
  title: `${game.value?.player1?.name} VS ${game.value?.player2?.name}`,
  description: game.value?.concluded_at ? `${getPlayer(game.value?.player1).name} - ${getPlayer(game.value?.player2).name}` : 'To be played',
  image: tournament.image,
})
</script>

<template>
  <UiPage padding>
    <GamesGameDetails
      v-if="game"
      :game="game"
      @refresh-request="refresh"
      @game-updated="updateGame"
    />
  </UiPage>
</template>
